export const API_TOKEN = "snd0itdoy4bpiuehtuskqnadau07nuzm";
export const CAPTCH_CLIENT_KEY: string =
  "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
export const FLOWBOX_CHECKOUT_API_KEY = "bcdaae511eeb77422a9db4a456d6bca5";
export const FLOWBOX_HOME_PAGE_FLOW_KEY = "xSZthKtcRtiHatsKoAbslQ";
export const FLOWBOX_PRODUCT_DETAILS_PAGE_FLOW_KEY = "zV0Lrt6ERLafxNrMs5oRzw";
export const FLOWBOX_CATEGORY_PAGE_FLOW_KEY = "HQUPPljuQUeXqVvFi4ocgA";
export const FLOWBOX_COMMUNITY_PAGE_FLOW_KEY = "zuMBx3PHSrCTCb7RboESsQ";
export const FLOWBOX_START_WIDGET_FLOW_KEY = "39a7ba4a-a226-4ddd-9000-e87c1adab82a";
export const FLOWBOX_REVIEW_WIDGET_FLOW_KEY = "adb5dd1f-5807-4a43-a03e-7fa041f1afca";